import { Component } from '@felicity/vision';
import {
  ProjectManager
} from '@felicity/multi-criteria-analysis';

/**
 * Projects screen
 */
export default class Projects extends Component {
  /**
   * Provides access to the project manager
   * @type {ProjectManager}
   */
  get projectManager() {
    return this.#manager;
  }

  /** @type {ProjectManager} */
  #manager;

  constructor() {
    super();

    this.#manager = new ProjectManager();
  }

  _prepare() {
    super._prepare();
    this.classList.add('screen');

    const uri = '/api/MCA/Project';
    this.projectManager.crudUri = uri;
    this.projectManager.urlTemplateOf('export', `${uri}/\${projectId}/Export`);
    this.projectManager.urlTemplateOf('area', `${uri}/\${projectId}/Area`);
    this.projectManager.urlTemplateOf('objects', '/api/Storage/RustFS/${bucketName}/Objects'); // eslint-disable-line no-template-curly-in-string
    this.projectManager.urlTemplateOf('upload', '/api/Storage/RustFS/${bucketName}'); // eslint-disable-line no-template-curly-in-string

    this.appendChild(this.projectManager);
    this.projectManager.grid.height = '100%';
    this.projectManager.grid.width = '100%';
  }
}

ProjectManager.register('project-manager');
